import styled, { keyframes } from 'styled-components'

export const fadeInUp = keyframes`
  from {
    opacity: 0;
    transform: translateY(20px); 
  }
  to {
    opacity: 1;
    transform: translateY(0); 
  }

`
export const Container = styled.div`
  background-color: #fff;
  border-radius: 20px;
  padding: 20px 10px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
  display: flex;
  flex-direction: column;
  height: 580px;
  overflow: hidden;
  margin-bottom: 20px;
  animation: ${fadeInUp} 0.6s ease-out forwards;

  @media (max-width: 768px) {
    padding: 10px 5px;
    border-radius: 15px;
  }
`

export const Title = styled.div`
  margin-bottom: 10px;
  color: ${(props) => props.theme.textPrimary};
  font-size: 16px;
  font-weight: bold;
  border-left: 4px solid #001d53;
  padding-left: 10px;
  flex-shrink: 0;

  @media (max-width: 768px) {
    font-size: 15px;
    margin-bottom: 5px;
  }
`

export const ScrollableY = styled.div`
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  flex: 1;
  padding-right: 5px;

  &::-webkit-scrollbar {
    width: 6px;
  }
  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 4px;
  }
  &::-webkit-scrollbar-thumb {
    background: #ccc;
    border-radius: 4px;
  }
  &::-webkit-scrollbar-thumb:hover {
    background: #aaa;
  }
`

export const ScrollableX = styled.div`
  overflow-x: auto;
  width: 100%;
  padding-bottom: 10px;

  &::-webkit-scrollbar {
    height: 6px;
  }
  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 4px;
  }
  &::-webkit-scrollbar-thumb {
    background: #ccc;
    border-radius: 4px;
  }
`

export const TableContent = styled.div`
  min-width: 900px;
  padding: 0 10px;

  @media (max-width: 768px) {
    min-width: 500px;
  }
`

export const HeaderRow = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 16px;
  gap: 8px;

  position: sticky;
  top: 0;
  background-color: #fff;
  z-index: 10;
  border-bottom: 1px solid #f0f0f0;

  font-weight: bold;
  color: #333;

  @media (max-width: 768px) {
    padding: 8px 10px;
    font-size: 13px;
  }
`

export const DataRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  position: relative;

  margin-bottom: 8px;
  padding: 10px 16px 14px 16px;
  border-bottom: 1px solid transparent;

  &:hover {
    background-color: #fafafa;
  }

  @media (max-width: 768px) {
    margin-bottom: 0px;
    padding: 6px 10px 8px 10px;
    border-bottom: 1px solid #f9f9f9;
    font-size: 13px;
  }
`

export const CellText = styled.p<{ align?: 'left' | 'right'; width?: number }>`
  width: ${(props) => (props.width ? `${props.width}px` : 'auto')};
  text-align: ${(props) => props.align || 'left'};
  margin: 0;

  @media (max-width: 768px) {
    font-size: 12px;
  }
`

export const VariationWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 4px;
  width: 300px;
`

export const BarsWrapper = styled.div`
  position: absolute;
  width: 100%;
  bottom: 0;
  left: 0;
  display: flex;
  gap: 2px;
  padding-right: 35px;
`

export const ProgressBar = styled.span<{ color: string; width: number }>`
  width: ${(props) => props.width}%;
  background-color: ${(props) => props.color};
  height: 5px;
  border-radius: 0 10px 0 10px;

  @media (max-width: 768px) {
    height: 4px;
  }
`
